/** ملفّاتُ أوضاع رفيف وأبعادُها (تُبنى بـ`.review/rafif-poses.mjs`، و`test/rafif-poses.test.ts` يطابق الأبعادَ بالملفّ) */
export type RafifPoseKind = 'point' | 'idea' | 'cheer' | 'oops' | 'sad';
export const POSES: Record<RafifPoseKind, { src: string; w: number; h: number }> = {
  point: { src: '/brand/rafif-point.webp', w: 480, h: 640 },
  idea: { src: '/brand/rafif-idea.webp', w: 405, h: 640 },
  cheer: { src: '/brand/rafif-cheer.webp', w: 310, h: 640 },
  oops: { src: '/brand/rafif-oops.webp', w: 292, h: 640 },
  sad: { src: '/brand/rafif-sad.webp', w: 416, h: 640 },
};
export const RAFIF_POSE_KINDS = Object.keys(POSES) as RafifPoseKind[];

/** كلُّ صور رفيف (الأوضاعُ الخمسة والرسمُ بالطول والوجه) — لتحميلها مسبقاً في بوابة الطفل */
export const RAFIF_IMAGE_SRCS: readonly string[] = ['/brand/rafif.webp', '/brand/rafif-face.webp', ...RAFIF_POSE_KINDS.map((k) => POSES[k].src)];

let warmed = false;
/**
 * تحميلُ صور رفيف كلِّها مرّةً واحدة عند دخول بوابة الطفل (29 سبتمبر 2026): كانت كلُّ صورةٍ تُطلب
 * أولَ ظهورها، فيقطع الانتقالُ من وضعٍ إلى وضع (تشير ← تهتف ← تتفاجأ) لحظةً بيضاء. الصورُ تبقى في
 * ذاكرة المتصفّح بعد التحميل فلا يُعاد طلبُها. لا تُنادى إلا في المتصفّح.
 */
export function warmRafifImages(): void {
  if (warmed || typeof Image === 'undefined') return;
  warmed = true;
  for (const src of RAFIF_IMAGE_SRCS) { const img = new Image(); img.decoding = 'async'; img.src = src; }
}
